// extracted by mini-css-extract-plugin
module.exports = {"image":"ImageBlock_image__samBu","caption":"ImageBlock_caption__A4Bzg","picture":"ImageBlock_picture__RMc4l"};